import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    // Iter-195 — clear the chatbot conversation BEFORE the API call so the
    // cleanup is guaranteed even if /auth/logout throws (e.g. expired token,
    // network glitch). The next user on this device cannot see prior msgs.
    try {
      sessionStorage.removeItem("baim_chatbot_messages_v1");
      sessionStorage.removeItem("baim_chatbot_session_v1");
    } catch { /* ignore */ }
    try {
      await api.post("/auth/logout");
    } catch { /* ignore — proceed with the local cleanup anyway */ }
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, logout, hasPermission: (p) => !!user?.permissions?.includes(p) }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
